export const layout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 6 },
    lg: { span: 5 },
    xl: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 18 },
    lg: { span: 19 },
    xl: { span: 20 },
  },
};

export const jabatanOptions = [
  "Sekretaris DPRD",
  "Kepala Bagian Umum",
  "Kepala Bagian Persidangan dan Perundang-undangan",
  "Plt. Kepala Bagian Fasilitasi Penganggaran dan Pengawasan (Analis Keuangan Pusat dan Daerah Ahli Muda)",
  "Plt. Kepala Bagian Program dan Keuangan (Analis Kebijakan Ahli Muda)",
  "Kepala Sub Bagian Tata Usaha dan Kepegawaian",
  "Penyuluh Hukum Ahli Muda",
  "Analis Kebijakan Ahli Muda",
  "Pranata Hubungan Masyarakat Ahli Muda",
  "Analis Keuangan Pusat dan Daerah Ahli Muda",
  "Analis Monitoring Evaluasi dan Pelaporan",
  "Analis Legislasi",
  "Analis Protokol",
  "Penyusun Risalah",
  "Analis Penganggaran",
  "Analis Tata Usaha",
  "Penyusun Laporan Keuangan",
  "Pengelola Peraturan Perundang-undangan",
  "Penyusun Rencana Kebutuhan Rumah Tangga dan Perlengkapan",
  "Analis Laporan Hasil Pengawasan",
  "Analis Aset Negara",
  "Analis Risalah",
  "Penyusun Naskah Rapat Pimpinan",
  "Pengadministrasi Umum",
  "Pranata Komputer Ahli Pertama",
  "Perencana Ahli Pertama",
  "Penyusun Materi Hukum dan Perundang-Undangan",
  "Analis Kebijakan Ahli Pertama",
  "Analis Sumber Daya Manusia Aparatur Ahli Pertama",
  "Penata Kelola Hukum dan Perundang-undangan",
  "Penata Kelola Sistem dan Teknologi Informasi",
  "Arsiparis Ahli Pertama",
  "Pranata Pasukan Pengamanan Dalam",
  "Pengadministrasi Pengaduan Publik",
  "Pengadministrasi Hukum",
  "Pengadministrasi Keuangan",
  "Pengadministrasi Perencanaan dan Program",
  "Pengelola Barang Milik Negara",
  "Pengelola Keuangan",
  "Asisten Legislatif Terampil",
  "Pranata Komputer Terampil",
  "Asisten Perisalah Legislatif Terampil",
  "Pengadministrasi Pemeliharaan Gedung Kantor",
];
